<template>
  <div class="bg-white d-flex align-items-center justify-content-center vh-100 flex-column">
      <h1>PAGE NOT FOUND</h1>
      <img src="@/assets/NO-SLEEP-GANG.gif" alt="">
      <a href="/" class="btn btn-primary mt-5">Go back to Home</a>
  </div>
</template>

<script>
export default {
    name: 'NotFound'
}
</script>

<style>

</style>